export { AccordionSpecificationItem } from './accordion-specification-item';
